var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TodayScheWidget"},[_c('p',[_vm._v("当天的课程")]),_c('div',{staticClass:"d_list pl-5"},_vm._l((_vm.datas),function(item){return _c('p',[_vm._v(_vm._s(item.information)+" / "+_vm._s(item.address)+" : "+_vm._s(item.schedulingStatus? '已结束' : '未结束')+" / "+_vm._s(item.timeDuration))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }